import { cn as e } from "../cn.js";
import t from "./style.js";
import * as n from "react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
// src/design/page-wrapper/index.tsx
var a = n.forwardRef(({ children: n, className: i, variant: a = "default", spacing: o = "sm", ...s }, c) => /* @__PURE__ */ r("div", {
	ref: c,
	className: e(t().root({
		variant: a,
		spacing: o
	}), i),
	...s,
	children: n
}));
a.displayName = "PageWrapper";
var o = n.forwardRef(({ children: n, className: a, sticky: o = !1, actions: s, ...c }, l) => {
	let u = t();
	return /* @__PURE__ */ r("div", {
		ref: l,
		className: e(u.header({ sticky: o }), a),
		...c,
		children: s ? /* @__PURE__ */ i("div", {
			className: u.headerRow(),
			children: [/* @__PURE__ */ r("div", {
				className: u.headerText(),
				children: n
			}), /* @__PURE__ */ r("div", {
				className: u.headerActions(),
				children: s
			})]
		}) : n
	});
});
o.displayName = "PageWrapper.Header";
var s = n.forwardRef(({ children: n, className: i, ...a }, o) => /* @__PURE__ */ r("h1", {
	ref: o,
	className: e(t().title(), i),
	...a,
	children: n
}));
s.displayName = "PageWrapper.Title";
var c = n.forwardRef(({ children: n, className: i, ...a }, o) => /* @__PURE__ */ r("p", {
	ref: o,
	className: e(t().description(), i),
	...a,
	children: n
}));
c.displayName = "PageWrapper.Description";
var l = n.forwardRef(({ children: n, className: i, ...a }, o) => /* @__PURE__ */ r("div", {
	ref: o,
	className: e(t().content(), i),
	...a,
	children: n
}));
l.displayName = "PageWrapper.Content";
var u = n.forwardRef(({ children: n, className: i, ...a }, o) => /* @__PURE__ */ r("div", {
	ref: o,
	className: e(t().footer(), i),
	...a,
	children: n
}));
u.displayName = "PageWrapper.Footer";
var d = Object.assign(a, {
	Header: o,
	Title: s,
	Description: c,
	Content: l,
	Footer: u
});
export { d as PageWrapper, d as default };

//# sourceMappingURL=index.js.map